module.exports = "\r\n\r\n<h2>Grid page here</h2>\r\n\r\n\r\n\r\n<ag-grid-angular class=\"ag-theme-fresh\"\r\n\r\n                 [gridOptions]=\"gridOptions\"\r\n                 [rowData]=\"rowData\"\r\n\r\n></ag-grid-angular>"


//////////////////
// WEBPACK FOOTER
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/sample/containers/grid-page/grid-page.html
// module id = ../../../../../src/app/sample/containers/grid-page/grid-page.html
// module chunks = main